export function TrimmerHandleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" aria-hidden="true" role="img">
      <path d="M16 14v-3h-3v9h-2V0h2v9h3V6l4 4-4 4ZM0 10l4 4v-3h3v9h2V0H7v9H4V6l-4 4Z" />
    </svg>
  );
}
